// extracted by mini-css-extract-plugin
export var layoutContainer = "_6u-0";
export var layoutContainerNoRounding = "_6u-6";
export var layoutContainerOpen = "_6u-5";
export var layoutContainerResizing = "_6u-1";
export var mainContent = "_6u-2";
export var resizeDivider = "_6u-3";
export var slidePanel = "_6u-4";